module.exports = __webpack_public_path__ + "static/consumer-digital-identity-trends-2023-69301db5ee2c945d125c36187d11f41b.webp";